import { createToastInterface } from "vue-toastification";
import { toastMessages, ToastType } from "./toastMessages";
import { AxiosResponse } from "axios";

// Define the expected response structure
interface ApiResponseData {
  message?: string;
  [key: string]: any;
}

interface ShowToastParams {
  response?: AxiosResponse<ApiResponseData> | null;
  type?: ToastType;
  message?: string;
}

const toast = createToastInterface();

export function showToast({ response, type, message }: ShowToastParams): void {
  let toastType: ToastType | undefined;
  let toastMessage: string | undefined;

  if (!response || response.status === undefined || response.status === null) {
    // No connection to server
    toastType = toastMessages.noConnection.type;
    toastMessage = toastMessages.noConnection.message;
  } else {
    const status = response.status;

    if (toastMessages[status]) {
      toastType = toastMessages[status].type;
      toastMessage = toastMessages[status].message;
    } else if (status >= 200 && status < 300) {
      toastType = "success";
      toastMessage = "Vorgang erfolgreich.";
    } else if (status >= 400 && status < 500) {
      toastType = "error";
      toastMessage = "Fehler. Bitte prüfe deine Anfrage.";
    } else if (status >= 500 && status < 600) {
      toastType = "error";
      toastMessage = "Serverfehler. Bitte später erneut versuchen.";
    } else {
      toastType = toastMessages.default.type;
      toastMessage = toastMessages.default.message;
    }

    // Backend message takes top priority if available
    if (response.data?.message) {
      toastMessage = response.data.message;
    }
  }

  // Manual overrides (if backend message was not present)
  if (!response?.data?.message && message) {
    toastMessage = message;
  }
  if (type) {
    toastType = type;
  }

  // Fallbacks
  if (!toastType) toastType = "info";
  if (!toastMessage) toastMessage = "Benachrichtigung";

  toast[toastType](toastMessage);
}
